export enum FullWidthBannerColorPalette {
  INFO = 'info',
  WARN = 'warning',
  ERROR = 'error',
  DEFERRED = 'deferred',
  ERROR_FADED = 'error-faded',
  WARN_FADED = 'warning-faded'
}

export enum FullWidthBannerContentColorPalette {
  INFO = 'info',
  WARN = 'warning',
  ERROR = 'error',
  DEFERRED = 'deferred'
}
